import type { FluxErrorEntityErrorCodes } from '../types.js';

export const FeaturesErrorCodes = {
  FeatureNotAvailableToAccount: {
    code: 'feature/not-available-to-account',
    explanation: 'O recurso que você está tentando acessar não está disponível para sua conta.',
    localizations: {},
    message: 'Este módulo não está disponível para a sua conta.',
  },
  FeatureNotFound: {
    code: 'feature/not-found',
    explanation: 'O recurso que você está tentando acessar não foi encontrado.',
    localizations: {},
    message: 'Módulo não encontrado.',
  },
} as const satisfies FluxErrorEntityErrorCodes<'feature'>;
